module.exports = __webpack_public_path__ + "static/06-4a4e9defd11e7344db056e4d739dc3fe.png";